import { render, staticRenderFns } from "./ExternalImage.vue?vue&type=template&id=1f13cddb&scoped=true&"
import script from "./ExternalImage.vue?vue&type=script&lang=js&"
export * from "./ExternalImage.vue?vue&type=script&lang=js&"
import style0 from "./ExternalImage.vue?vue&type=style&index=0&id=1f13cddb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f13cddb",
  null
  
)

export default component.exports